import { useBemCN } from '@gik/core/utils/bemBlock';
import { LayoutAside, PageSection, SvgIcon } from '@gik/ui';
import React from 'react';
import { CRMNavigation, CRMNavigationItem } from '../CRMNavigation';
import { translationKeys } from '../../i18n/en';
import { useTranslation } from 'react-i18next';
import Link from '@/components/Link';
import { useInkindStore } from '@gik/inkind/store/InkindStore';

export type CRMLayoutProps = {};

export const CRMLayout: React.FC<React.PropsWithChildren<CRMLayoutProps>> = ({ children }) => {
  const bem = useBemCN('crm-layout');
  const { t } = useTranslation();

  const inkindRouteId = useInkindStore(state => state.inkindRouteId);

  const navigationItems: CRMNavigationItem[] = React.useMemo<CRMNavigationItem[]>(
    () => [
      {
        id: 'supporters',
        label: 'Supporters',
        icon: 'UserGroupOutline',
        link: `/inkinds/${inkindRouteId}/admin/supporters`,
      },
    ],
    [inkindRouteId]
  );

  return (
    <PageSection variant="lightgray" noPad {...bem()}>
      <LayoutAside {...bem('layout')}>
        <aside {...bem('aside')}>
          <Link href={`/inkinds/${inkindRouteId}`}>
            <a>
              <div {...bem('aside-return')}>
                <SvgIcon name="ArrowLeft" />
                {t(translationKeys.returnToInkindPage)}
              </div>
            </a>
          </Link>

          {/* Navigation should only display on desktop */}
          <CRMNavigation items={navigationItems} />
          {/* on mobile only the title is shown without a navigation (temporary) */}
          <div {...bem('mobile-header')}>
            <SvgIcon size="lg" name="UserGroupOutline" />
            {t(translationKeys.supporters)}
          </div>
        </aside>
        <main {...bem('main')}>{children}</main>
      </LayoutAside>
    </PageSection>
  );
};
